// extracted by mini-css-extract-plugin
export var attachButton = "_c8-8";
export var sendButton = "_c8-2";
export var sendDisabled = "_c8-4";
export var sendEnabled = "_c8-3";
export var sendIcon = "_c8-6";
export var sendIconDisabled = "_c8-7";
export var sendStreaming = "_c8-5";
export var textarea = "_c8-1";
export var wrapper = "_c8-0";